export default "__VITE_ASSET__Pt8mMtth__"